import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = { class: "hero-image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "features" }
const _hoisted_7 = { class: "features-grid" }
const _hoisted_8 = { class: "feature-card" }
const _hoisted_9 = { class: "feature-image" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "feature-card" }
const _hoisted_12 = { class: "feature-image" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "feature-card" }
const _hoisted_15 = { class: "feature-image" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "feature-card" }
const _hoisted_18 = { class: "feature-image" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "products" }
const _hoisted_21 = { class: "products-grid" }
const _hoisted_22 = { class: "product-image" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "product-image" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "product-image" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "contact" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ContactForm = _resolveComponent("ContactForm")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createBlock(_component_AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "hero-title" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor. ", -1)),
            _createElementVNode("a", {
              href: "#",
              class: "hero-cta",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.trackHeroCta && $options.trackHeroCta(...args)))
            }, "Lorem Ipsum")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: $data.placeholderImg,
              alt: ""
            }, null, 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("section", _hoisted_6, [
          _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "section-title" }, "Lorem ipsum dolor sit amet consectetur", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: $data.placeholderImg,
                  alt: ""
                }, null, 8, _hoisted_10)
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "feature-title" }, "Lorem ipsum dolor", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "feature-text" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam. ", -1))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("img", {
                  src: $data.placeholderImg,
                  alt: ""
                }, null, 8, _hoisted_13)
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "feature-title" }, "Consectetur adipiscing", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "feature-text" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis nostrud exercitation. ", -1))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  src: $data.placeholderImg,
                  alt: ""
                }, null, 8, _hoisted_16)
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "feature-title" }, "Sed do eiusmod tempor", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "feature-text" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ullamco laboris nisi. ", -1))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("img", {
                  src: $data.placeholderImg,
                  alt: ""
                }, null, 8, _hoisted_19)
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "feature-title" }, "Incididunt ut labore", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "feature-text" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor. ", -1))
            ])
          ])
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("section", { class: "news" }, [
          _createElementVNode("h2", { class: "section-title" }, "Lorem Ipsum"),
          _createElementVNode("div", { class: "news-content" }, [
            _createElementVNode("p", { class: "news-text" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris. "),
            _createElementVNode("a", {
              href: "#",
              class: "news-link"
            }, "Lorem Ipsum →")
          ])
        ], -1)),
        _createElementVNode("section", _hoisted_20, [
          _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "section-title" }, "Lorem ipsum dolor", -1)),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_router_link, {
              to: "/product/sliding-drives",
              class: "product-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("img", {
                    src: $data.placeholderImg,
                    alt: ""
                  }, null, 8, _hoisted_23)
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "product-title" }, "Lorem ipsum dolor sit amet consectetur", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "product-link" }, "Lorem Ipsum →", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/product/proff",
              class: "product-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("img", {
                    src: $data.placeholderImg,
                    alt: ""
                  }, null, 8, _hoisted_25)
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "product-title" }, "Consectetur adipiscing elit r. r.", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "product-link" }, "Lorem Ipsum →", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/product/telescopic",
              class: "product-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("img", {
                    src: $data.placeholderImg,
                    alt: ""
                  }, null, 8, _hoisted_27)
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "product-title" }, "Sed do eiusmod tempor r. r.", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "product-link" }, "Lorem Ipsum →", -1))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_28, [
          _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "section-title" }, "Оставьте заявку и мы свяжемся с вами", -1)),
          _createVNode(_component_ContactForm)
        ])
      ])
    ]),
    _: 1
  }))
}